export const outerWidth = (el) => {
	let width = el.offsetWidth;
	const style = getComputedStyle(el);

	width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
	return width;
};



// WEBPACK FOOTER //
// ./src/scripts/carousel/Dimensions.js